<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal">
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar puesto' : 'Nuevo puesto' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <form class="mod-modal-body" @submit.prevent="handleSubmit">
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid puesto-grid">
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input id="Clave" v-model="form.Clave" type="text" :disabled="isEdit" required maxlength="50"
              placeholder="GERVEN" style="text-transform:uppercase">
          </div>
          <div class="mod-field puesto-span2">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input id="Nombre" v-model="form.Nombre" type="text" required maxlength="120"
              placeholder="Gerente de Ventas">
          </div>

          <div class="mod-field puesto-span2">
            <label for="Familia">Familia / Categoría</label>
            <input id="Familia" v-model="form.Familia" type="text" maxlength="80"
              placeholder="Dirección, Operativa, Soporte, Comercial...">
          </div>
          <div class="mod-field">
            <label for="Nivel">Nivel jerárquico</label>
            <input id="Nivel" v-model.number="form.Nivel" type="number" min="0" max="99"
              placeholder="0 = sin nivel">
          </div>

          <div class="mod-field puesto-span3">
            <label for="Descripcion">Descripción</label>
            <input id="Descripcion" v-model="form.Descripcion" type="text" maxlength="255"
              placeholder="Resumen de responsabilidades del puesto">
          </div>

          <div class="mod-field puesto-span2">
            <label for="ClaveErp">Clave ERP</label>
            <input id="ClaveErp" v-model="form.ClaveErp" type="text" maxlength="50"
              placeholder="Mapeo con sistema ERP">
          </div>
          <div class="mod-field mod-field-check" style="align-self:end;padding-bottom:0.45rem">
            <label class="mod-check-label">
              <input v-model="form.EsActivo" type="checkbox">
              <span>Activo</span>
            </label>
          </div>
        </div>

        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">Cancelar</button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear puesto' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import authService from '@/services/auth';
import { showToast } from '@/shared/utils/toast';
import { createPuesto } from './puesto.model';
import puestoService from './puesto.service';

export default {
  name: 'PuestoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createPuesto(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;
      if (!this.form.Clave || !this.form.Nombre) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }
      try {
        const result = await puestoService.guardar({
          ...this.form,
          Clave: String(this.form.Clave || '').trim().toUpperCase()
        });
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch {
        this.error = 'Error de conexión con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";

.puesto-grid {
  grid-template-columns: repeat(3, 1fr);
}

.puesto-span2 { grid-column: span 2; }
.puesto-span3 { grid-column: span 3; }

@media (max-width: 640px) {
  .puesto-grid { grid-template-columns: 1fr; }
  .puesto-span2,
  .puesto-span3 { grid-column: span 1; }
}
</style>
